import CryptoJS from 'crypto-js';

const AES_KEY = CryptoJS.enc.Utf8.parse('12345678901234561234567890123456');
const AES_IV = CryptoJS.enc.Utf8.parse('1234567890123456');

/**
 * Decrypts an AES-CBC encrypted string and returns the parsed JSON object.
 * @param token - URL-encoded, Base64 AES-encrypted string
 * @returns Parsed object of type T, or null if decryption/parsing fails
 */
export const decryptData = <T>(token: string): T | null => {
  // debugger;
  try {
    const bytes = CryptoJS.AES.decrypt(
      decodeURIComponent(token),
      AES_KEY,
      {
        iv: AES_IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) {
      console.error('decryptData: decryption produced empty string');
      return null;
    }

    return JSON.parse(decrypted) as T;
  } catch (err) {
    console.error('decryptData: failed to decrypt or parse token:', err);
    return null;
  }
};
